import dayjs from 'dayjs';

export class MockedVitoairFeatures {
  mock(installationId: number, gatewaySerial: string) {
    return [
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.operating.modes.filterChange',
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.modes.filterChange',
        timestamp: '2022-11-02T20:32:31.318Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 0,
            unit: 'cubicMeter/hour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.volumeFlow.current.input',
        gatewayId: gatewaySerial,
        feature: 'ventilation.volumeFlow.current.input',
        timestamp: '2022-11-02T20:32:31.320Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          volumeFlow: {
            type: 'number',
            value: 234,
            unit: 'cubicMeter/hour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.operating.programs.levelFour',
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.programs.levelFour',
        timestamp: '2022-11-02T20:32:31.274Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          volumeFlow: {
            type: 'number',
            value: 126,
            unit: 'cubicMeter/hour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.operating.programs.levelTwo',
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.programs.levelTwo',
        timestamp: '2022-11-02T20:32:31.267Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 87,
            unit: 'percent',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.heating.recovery',
        gatewayId: gatewaySerial,
        feature: 'ventilation.heating.recovery',
        timestamp: '2022-11-02T20:32:31.299Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          volumeFlow: {
            type: 'number',
            value: 126,
            unit: 'cubicMeter/hour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.levels.levelTwo',
        gatewayId: gatewaySerial,
        feature: 'ventilation.levels.levelTwo',
        timestamp: '2022-11-02T20:32:31.277Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'array',
            value: [
              {
                busAddress: 1,
                busType: 'CanExternal',
                deviceObjectProperty: 'VCUMaster',
                deviceFunction: 'Nothing',
                softwareVersion: '0016.0500.2228.0133',
                hardwareVersion: '0000.0000.0000.0000',
                etn: '7892763-device-serial',
              },
              {
                busAddress: 58,
                busType: 'InternalUart',
                deviceObjectProperty: 'BackendGateway',
                deviceFunction: 'Nothing',
                softwareVersion: '0041.0504.2222.0043',
                hardwareVersion: '0041.0400.0200.0000',
                etn: gatewaySerial,
              },
            ],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.busTopology',
        gatewayId: gatewaySerial,
        feature: 'device.busTopology',
        timestamp: '2022-11-02T20:32:31.213Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.operating.programs.automatic',
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.programs.automatic',
        timestamp: '2022-11-02T20:32:31.318Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          remainingRuntime: {
            value: 0,
            unit: 'minutes',
            type: 'number',
          },
          defaultRuntime: {
            value: 30,
            unit: 'minutes',
            type: 'number',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.quickmodes.silent/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {
              timeout: {
                type: 'number',
                required: false,
                constraints: {
                  min: 1,
                  max: 1440,
                  stepping: 1,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.quickmodes.silent/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
          setTimeout: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.quickmodes.silent/commands/setTimeout',
            name: 'setTimeout',
            isExecutable: true,
            params: {
              timeout: {
                type: 'number',
                required: true,
                constraints: {
                  min: 1,
                  max: 1440,
                  stepping: 1,
                },
              },
            },
          },
          setDefaultRuntime: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.quickmodes.silent/commands/setDefaultRuntime',
            name: 'setDefaultRuntime',
            isExecutable: true,
            params: {
              defaultRuntime: {
                type: 'number',
                required: true,
                constraints: {
                  min: 1,
                  max: 1440,
                  stepping: 1,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.quickmodes.silent',
        gatewayId: gatewaySerial,
        feature: 'ventilation.quickmodes.silent',
        timestamp: '2022-11-02T13:59:05.607Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          remainingRuntime: {
            value: 0,
            unit: 'minutes',
            type: 'number',
          },
          defaultRuntime: {
            value: 720,
            unit: 'minutes',
            type: 'number',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.quickmodes.temporaryShutdown/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {
              timeout: {
                type: 'number',
                required: false,
                constraints: {
                  min: 1,
                  max: 1440,
                  stepping: 1,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.quickmodes.temporaryShutdown/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
          setTimeout: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.quickmodes.temporaryShutdown/commands/setTimeout',
            name: 'setTimeout',
            isExecutable: true,
            params: {
              timeout: {
                type: 'number',
                required: true,
                constraints: {
                  min: 1,
                  max: 1440,
                  stepping: 1,
                },
              },
            },
          },
          setDefaultRuntime: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.quickmodes.temporaryShutdown/commands/setDefaultRuntime',
            name: 'setDefaultRuntime',
            isExecutable: true,
            params: {
              defaultRuntime: {
                type: 'number',
                required: true,
                constraints: {
                  min: 1,
                  max: 1440,
                  stepping: 1,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.quickmodes.temporaryShutdown',
        gatewayId: gatewaySerial,
        feature: 'ventilation.quickmodes.temporaryShutdown',
        timestamp: '2022-11-02T13:59:05.607Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          current: {
            type: 'number',
            value: 1107,
            unit: 'rotationPerMinute',
          },
          target: {
            type: 'number',
            value: 0,
            unit: 'rotationPerMinute',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.fan.exhaust',
        gatewayId: gatewaySerial,
        feature: 'ventilation.fan.exhaust',
        timestamp: '2022-11-02T20:32:31.320Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: true,
          },
          volumeFlow: {
            type: 'number',
            value: 54,
            unit: 'cubicMeter/hour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.operating.programs.levelOne',
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.programs.levelOne',
        timestamp: '2022-11-02T20:32:31.266Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'off',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.heatExchanger.frostprotection',
        gatewayId: gatewaySerial,
        feature: 'ventilation.heatExchanger.frostprotection',
        timestamp: '2022-11-02T20:32:31.254Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 783,
            unit: 'hour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.fan.exhaust.runtime',
        gatewayId: gatewaySerial,
        feature: 'ventilation.fan.exhaust.runtime',
        timestamp: '2022-11-02T20:32:31.290Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: '7892763-device-serial',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.serial',
        gatewayId: gatewaySerial,
        feature: 'device.serial',
        timestamp: '2022-11-02T20:32:31.215Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'array',
            value: [],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.info.raw',
        gatewayId: gatewaySerial,
        feature: 'device.messages.info.raw',
        timestamp: '2022-11-02T20:32:31.296Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: 'levelOne',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.operating.programs.active',
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.programs.active',
        timestamp: '2022-11-02T20:32:31.281Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [],
              current: [],
              gone: [],
            },
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.warnings.active',
        gatewayId: gatewaySerial,
        feature: 'device.messages.warnings.active',
        timestamp: '2022-10-24T21:14:11.268Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          current: {
            type: 'number',
            value: 1209,
            unit: 'rotationPerMinute',
          },
          target: {
            type: 'number',
            value: 0,
            unit: 'rotationPerMinute',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.fan.supply',
        gatewayId: gatewaySerial,
        feature: 'ventilation.fan.supply',
        timestamp: '2022-11-02T20:32:31.289Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          volumeFlow: {
            type: 'number',
            value: 180,
            unit: 'cubicMeter/hour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.operating.programs.levelThree',
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.programs.levelThree',
        timestamp: '2022-11-02T20:32:31.270Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.operating.modes.sensorDriven',
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.modes.sensorDriven',
        timestamp: '2022-11-02T20:32:31.306Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          entries: {
            value: {
              mon: [
                {
                  mode: 'levelTwo',
                  start: '06:00',
                  end: '22:00',
                  position: 0,
                },
              ],
              tue: [
                {
                  mode: 'levelTwo',
                  start: '06:00',
                  end: '22:00',
                  position: 0,
                },
              ],
              wed: [
                {
                  mode: 'levelTwo',
                  start: '06:00',
                  end: '22:00',
                  position: 0,
                },
              ],
              thu: [
                {
                  mode: 'levelTwo',
                  start: '06:00',
                  end: '22:00',
                  position: 0,
                },
              ],
              fri: [
                {
                  mode: 'levelTwo',
                  start: '06:00',
                  end: '22:00',
                  position: 0,
                },
              ],
              sat: [
                {
                  mode: 'levelTwo',
                  start: '06:00',
                  end: '22:00',
                  position: 0,
                },
              ],
              sun: [
                {
                  mode: 'levelTwo',
                  start: '06:00',
                  end: '22:00',
                  position: 0,
                },
              ],
            },
            type: 'Schedule',
          },
        },
        commands: {
          setSchedule: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.schedule/commands/setSchedule',
            name: 'setSchedule',
            isExecutable: true,
            params: {
              newSchedule: {
                type: 'Schedule',
                required: true,
                constraints: {
                  modes: ['levelTwo', 'levelThree'],
                  maxEntries: 4,
                  resolution: 10,
                  defaultMode: 'levelOne',
                  overlapAllowed: false,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.schedule',
        gatewayId: gatewaySerial,
        feature: 'ventilation.schedule',
        timestamp: '2022-11-02T13:59:05.607Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 45.6,
            unit: 'partsPerMinute',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.airQuality.co2.current',
        gatewayId: gatewaySerial,
        feature: 'ventilation.airQuality.co2.current',
        timestamp: '2022-11-02T20:32:31.258Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 872,
            unit: 'hour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.fan.supply.runtime',
        gatewayId: gatewaySerial,
        feature: 'ventilation.fan.supply.runtime',
        timestamp: '2022-11-02T20:32:31.288Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          latitude: {
            type: 'number',
            value: 0,
            unit: 'degree',
          },
          longitude: {
            type: 'number',
            value: 0,
            unit: 'degree',
          },
          altitude: {
            type: 'number',
            value: 0,
            unit: 'meter',
          },
        },
        commands: {
          setLocation: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.configuration.houseLocation/commands/setLocation',
            name: 'setLocation',
            isExecutable: true,
            params: {
              latitude: {
                required: true,
                constraints: {
                  min: -90,
                  max: 90,
                  stepping: 0.0001,
                },
                type: 'number',
              },
              longitude: {
                required: true,
                constraints: {
                  min: -180,
                  max: 180,
                  stepping: 0.0001,
                },
                type: 'number',
              },
              altitude: {
                required: true,
                constraints: {
                  min: 0,
                  max: 8848,
                  stepping: 1,
                },
                type: 'number',
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration.houseLocation',
        gatewayId: gatewaySerial,
        feature: 'heating.configuration.houseLocation',
        timestamp: '2022-11-02T20:32:31.224Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'notConnected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.airQuality.temperature.current',
        gatewayId: gatewaySerial,
        feature: 'ventilation.airQuality.temperature.current',
        timestamp: '2022-11-02T20:32:31.256Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          volumeFlow: {
            type: 'number',
            value: 180,
            unit: 'cubicMeter/hour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.levels.levelThree',
        gatewayId: gatewaySerial,
        feature: 'ventilation.levels.levelThree',
        timestamp: '2022-11-02T20:32:31.276Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'notConnected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.sensors.humidity.exhaust',
        gatewayId: gatewaySerial,
        feature: 'ventilation.sensors.humidity.exhaust',
        timestamp: '2022-11-02T20:32:31.317Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.operating.modes.ventilation',
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.modes.ventilation',
        timestamp: '2022-11-02T20:32:31.304Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {
          setLevel: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.operating.modes.permanent/commands/setLevel',
            name: 'setLevel',
            isExecutable: true,
            params: {
              level: {
                type: 'string',
                required: true,
                constraints: {
                  enum: ['levelOne', 'levelTwo', 'levelThree', 'levelFour'],
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.operating.modes.permanent',
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.modes.permanent',
        timestamp: '2022-11-02T13:59:05.607Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.bypass.operating.modes.off',
        gatewayId: gatewaySerial,
        feature: 'ventilation.bypass.operating.modes.off',
        timestamp: '2022-11-02T20:32:31.245Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 0,
            unit: 'percent',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.bypass.position',
        gatewayId: gatewaySerial,
        feature: 'ventilation.bypass.position',
        timestamp: '2022-11-02T20:32:31.250Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          serviceIntervalMonths: {
            value: 24,
            unit: '',
            type: 'number',
          },
          serviceDue: {
            value: true,
            type: 'boolean',
          },
          nextService: {
            value: '2002-01-01',
            type: 'string',
          },
          lastService: {
            value: '2000-01-01',
            type: 'string',
          },
          activeMonthSinceLastService: {
            value: 250,
            unit: '',
            type: 'number',
          },
        },
        commands: {
          confirmService: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.service.timeBased/commands/confirmService',
            name: 'confirmService',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.service.timeBased',
        gatewayId: gatewaySerial,
        feature: 'heating.service.timeBased',
        timestamp: '2022-11-02T13:59:05.607Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {},
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.features.temperatureHumidity',
        gatewayId: gatewaySerial,
        feature: 'ventilation.features.temperatureHumidity',
        timestamp: '2022-11-02T13:59:05.607Z',
        isEnabled: true,
        isReady: false,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.operating.modes.sensorOverride',
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.modes.sensorOverride',
        timestamp: '2022-11-02T20:32:31.305Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'array',
            value: [
              {
                priority: 'service',
                timestamp: '2022-10-28T14:32:56.000Z',
                accessLevel: 'customer',
                errorCode: 'P.1',
                audiences: [
                  'IS-SUPPLIER',
                  'IS-DEVELOPMENT',
                  'IS-MANUFACTURING',
                  'IS-AFTERSALES',
                  'IS-AFTERMARKET',
                  'IS-DEVELOPER-VEG',
                  'IS-BIG-DATA',
                  'IS-MANUFACTURING-VEG',
                ],
              },
            ],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.service.raw',
        gatewayId: gatewaySerial,
        feature: 'device.messages.service.raw',
        timestamp: '2022-11-02T20:32:31.298Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: true,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.bypass',
        gatewayId: gatewaySerial,
        feature: 'ventilation.bypass',
        timestamp: '2022-11-02T20:32:31.231Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {},
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.features',
        gatewayId: gatewaySerial,
        feature: 'ventilation.features',
        timestamp: '2022-11-02T20:32:31.333Z',
        isEnabled: true,
        isReady: false,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          remainingRuntime: {
            value: 0,
            unit: 'minutes',
            type: 'number',
          },
          defaultRuntime: {
            value: 30,
            unit: 'minutes',
            type: 'number',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.quickmodes.forcedLevelFour/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {
              timeout: {
                type: 'number',
                required: false,
                constraints: {
                  min: 1,
                  max: 1440,
                  stepping: 1,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.quickmodes.forcedLevelFour/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
          setTimeout: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.quickmodes.forcedLevelFour/commands/setTimeout',
            name: 'setTimeout',
            isExecutable: true,
            params: {
              timeout: {
                type: 'number',
                required: true,
                constraints: {
                  min: 1,
                  max: 1440,
                  stepping: 1,
                },
              },
            },
          },
          setDefaultRuntime: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.quickmodes.forcedLevelFour/commands/setDefaultRuntime',
            name: 'setDefaultRuntime',
            isExecutable: true,
            params: {
              defaultRuntime: {
                type: 'number',
                required: true,
                constraints: {
                  min: 1,
                  max: 1440,
                  stepping: 1,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.quickmodes.forcedLevelFour',
        gatewayId: gatewaySerial,
        feature: 'ventilation.quickmodes.forcedLevelFour',
        timestamp: '2022-11-02T13:59:05.607Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 0,
            unit: 'cubicMeter/hour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.volumeFlow.current.output',
        gatewayId: gatewaySerial,
        feature: 'ventilation.volumeFlow.current.output',
        timestamp: '2022-11-02T20:32:31.311Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.bypass.operating.modes.active',
        gatewayId: gatewaySerial,
        feature: 'ventilation.bypass.operating.modes.active',
        timestamp: '2022-11-02T20:32:31.248Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'notConnected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.sensors.temperature.exhaust',
        gatewayId: gatewaySerial,
        feature: 'ventilation.sensors.temperature.exhaust',
        timestamp: '2022-11-02T20:32:31.314Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          day: {
            type: 'array',
            value: [0, 0.2, 0.2, 0.1, 0.2, 0.2, 0.1, 0.2],
            unit: 'kilowattHour',
          },
          week: {
            type: 'array',
            value: [0.5, 1.2, 1.2, 1.2, 0.5],
            unit: 'kilowattHour',
          },
          month: {
            type: 'array',
            value: [0.4, 4.2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            unit: 'kilowattHour',
          },
          year: {
            type: 'array',
            value: [4.6, 0],
            unit: 'kilowattHour',
          },
          dayValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          weekValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          monthValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          yearValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.power.consumption.total',
        gatewayId: gatewaySerial,
        feature: 'ventilation.power.consumption.total',
        timestamp: '2022-11-02T23:02:43.585Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'notConnected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.zigbee.status',
        gatewayId: gatewaySerial,
        feature: 'device.zigbee.status',
        timestamp: '2022-11-02T20:32:31.216Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: '7892763-device-serial',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.serial',
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.serial',
        timestamp: '2022-11-02T20:32:31.214Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'notConnected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.airQuality.organicComponents.current',
        gatewayId: gatewaySerial,
        feature: 'ventilation.airQuality.organicComponents.current',
        timestamp: '2022-11-02T20:32:31.257Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          volumeFlow: {
            type: 'number',
            value: 0,
            unit: 'cubicMeter/hour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.operating.programs.standby',
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.programs.standby',
        timestamp: '2022-11-02T20:32:31.265Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          remainingRuntime: {
            value: 0,
            unit: 'minutes',
            type: 'number',
          },
          defaultRuntime: {
            value: 30,
            unit: 'minutes',
            type: 'number',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.operating.programs.silent/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {
              timeout: {
                type: 'number',
                required: false,
                constraints: {
                  min: 1,
                  max: 1440,
                  stepping: 1,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.operating.programs.silent/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
          setTimeout: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.operating.programs.silent/commands/setTimeout',
            name: 'setTimeout',
            isExecutable: true,
            params: {
              timeout: {
                type: 'number',
                required: true,
                constraints: {
                  min: 1,
                  max: 1440,
                  stepping: 1,
                },
              },
            },
          },
          setDefaultRuntime: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.operating.programs.silent/commands/setDefaultRuntime',
            name: 'setDefaultRuntime',
            isExecutable: true,
            params: {
              defaultRuntime: {
                type: 'number',
                required: true,
                constraints: {
                  min: 1,
                  max: 1440,
                  stepping: 1,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.operating.programs.silent',
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.programs.silent',
        timestamp: '2022-11-02T13:59:05.607Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          volumeFlow: {
            type: 'number',
            value: 234,
            unit: 'cubicMeter/hour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.levels.levelFour',
        gatewayId: gatewaySerial,
        feature: 'ventilation.levels.levelFour',
        timestamp: '2022-11-02T20:32:31.275Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'array',
            value: [
              {
                priority: 'criticalError',
                timestamp: '2022-10-28T14:33:53.000Z',
                accessLevel: 'customer',
                errorCode: 'F.902',
                audiences: [
                  'IS-SUPPLIER',
                  'IS-DEVELOPMENT',
                  'IS-MANUFACTURING',
                  'IS-AFTERSALES',
                  'IS-AFTERMARKET',
                  'IS-DEVELOPER-VEG',
                  'IS-BIG-DATA',
                  'IS-MANUFACTURING-VEG',
                ],
              },
              {
                priority: 'criticalError',
                timestamp: '2022-10-28T14:33:53.000Z',
                accessLevel: 'customer',
                errorCode: 'F.904',
                audiences: [
                  'IS-SUPPLIER',
                  'IS-DEVELOPMENT',
                  'IS-MANUFACTURING',
                  'IS-AFTERSALES',
                  'IS-AFTERMARKET',
                  'IS-DEVELOPER-VEG',
                  'IS-BIG-DATA',
                  'IS-MANUFACTURING-VEG',
                ],
              },
              {
                priority: 'criticalError',
                timestamp: '2022-10-28T14:33:53.000Z',
                accessLevel: 'customer',
                errorCode: 'F.900',
                audiences: [
                  'IS-SUPPLIER',
                  'IS-DEVELOPMENT',
                  'IS-MANUFACTURING',
                  'IS-AFTERSALES',
                  'IS-AFTERMARKET',
                  'IS-DEVELOPER-VEG',
                  'IS-BIG-DATA',
                  'IS-MANUFACTURING-VEG',
                ],
              },
              {
                priority: 'criticalError',
                timestamp: '2022-10-28T14:33:53.000Z',
                accessLevel: 'customer',
                errorCode: 'F.898',
                audiences: [
                  'IS-SUPPLIER',
                  'IS-DEVELOPMENT',
                  'IS-MANUFACTURING',
                  'IS-AFTERSALES',
                  'IS-AFTERMARKET',
                  'IS-DEVELOPER-VEG',
                  'IS-BIG-DATA',
                  'IS-MANUFACTURING-VEG',
                ],
              },
              {
                priority: 'criticalError',
                timestamp: '2022-10-28T14:33:06.000Z',
                accessLevel: 'customer',
                errorCode: 'F.520',
                audiences: [
                  'IS-SUPPLIER',
                  'IS-DEVELOPMENT',
                  'IS-MANUFACTURING',
                  'IS-AFTERSALES',
                  'IS-AFTERMARKET',
                  'IS-DEVELOPER-VEG',
                  'IS-BIG-DATA',
                  'IS-MANUFACTURING-VEG',
                ],
              },
              {
                priority: 'criticalError',
                timestamp: '2022-10-28T14:33:06.000Z',
                accessLevel: 'customer',
                errorCode: 'F.520',
                audiences: [
                  'IS-SUPPLIER',
                  'IS-DEVELOPMENT',
                  'IS-MANUFACTURING',
                  'IS-AFTERSALES',
                  'IS-AFTERMARKET',
                  'IS-DEVELOPER-VEG',
                  'IS-BIG-DATA',
                  'IS-MANUFACTURING-VEG',
                ],
              },
            ],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.errors.raw',
        gatewayId: gatewaySerial,
        feature: 'device.messages.errors.raw',
        timestamp: '2022-11-02T20:32:31.292Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: true,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation',
        gatewayId: gatewaySerial,
        feature: 'ventilation',
        timestamp: '2022-11-02T20:32:31.228Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [],
              current: [],
              gone: [],
            },
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.status.active',
        gatewayId: gatewaySerial,
        feature: 'device.messages.status.active',
        timestamp: '2022-10-24T21:14:11.281Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'notConnected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.sensors.temperature.supply',
        gatewayId: gatewaySerial,
        feature: 'ventilation.sensors.temperature.supply',
        timestamp: '2022-11-02T20:32:31.258Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          remainingRuntime: {
            value: 0,
            unit: 'minutes',
            type: 'number',
          },
          defaultRuntime: {
            value: 30,
            unit: 'minutes',
            type: 'number',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.operating.programs.forcedLevelFour/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {
              timeout: {
                type: 'number',
                required: false,
                constraints: {
                  min: 1,
                  max: 1440,
                  stepping: 1,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.operating.programs.forcedLevelFour/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
          setTimeout: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.operating.programs.forcedLevelFour/commands/setTimeout',
            name: 'setTimeout',
            isExecutable: true,
            params: {
              timeout: {
                type: 'number',
                required: true,
                constraints: {
                  min: 1,
                  max: 1440,
                  stepping: 1,
                },
              },
            },
          },
          setDefaultRuntime: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.operating.programs.forcedLevelFour/commands/setDefaultRuntime',
            name: 'setDefaultRuntime',
            isExecutable: true,
            params: {
              defaultRuntime: {
                type: 'number',
                required: true,
                constraints: {
                  min: 1,
                  max: 1440,
                  stepping: 1,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.operating.programs.forcedLevelFour',
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.programs.forcedLevelFour',
        timestamp: '2022-11-02T13:59:05.607Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            unit: 'minute',
            value: 59,
            type: 'number',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.device.time.offset',
        gatewayId: gatewaySerial,
        feature: 'heating.device.time.offset',
        timestamp: '2022-11-02T20:32:37.038Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'connected',
          },
          minValue: {
            type: 'number',
            value: 8220,
            unit: 'partsPerMinute',
          },
          maxValue: {
            type: 'number',
            value: 8220,
            unit: 'partsPerMinute',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.airQuality.humidity.current',
        gatewayId: gatewaySerial,
        feature: 'ventilation.airQuality.humidity.current',
        timestamp: '2022-11-02T20:32:31.273Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: true,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.bypass.operating.modes.automaticSmoothRegulation',
        gatewayId: gatewaySerial,
        feature: 'ventilation.bypass.operating.modes.automaticSmoothRegulation',
        timestamp: '2022-11-02T20:32:31.249Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.lock.external',
        gatewayId: gatewaySerial,
        feature: 'device.lock.external',
        timestamp: '2022-11-02T20:32:31.238Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.bypass.operating.modes.open',
        gatewayId: gatewaySerial,
        feature: 'ventilation.bypass.operating.modes.open',
        timestamp: '2022-11-02T20:32:31.247Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 32,
            unit: '',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.sensors.airQuality',
        gatewayId: gatewaySerial,
        feature: 'ventilation.sensors.airQuality',
        timestamp: '2022-11-02T20:32:31.251Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [],
              current: [],
              gone: [],
            },
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.info.active',
        gatewayId: gatewaySerial,
        feature: 'device.messages.info.active',
        timestamp: '2022-11-01T22:01:13.036Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            value: 'automaticSmoothRegulation',
            type: 'string',
          },
          state: {
            value: 'automatic',
            type: 'string',
          },
          level: {
            value: 'smoothRegulationMode',
            type: 'string',
          },
        },
        commands: {
          setMode: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.bypass.operating.modes.active/commands/setMode',
            name: 'setMode',
            isExecutable: true,
            params: {
              mode: {
                type: 'string',
                required: true,
                constraints: {
                  enum: ['off', 'automaticSmoothRegulation', 'automaticDynamicRegulation'],
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.bypass.operating.modes.active',
        gatewayId: gatewaySerial,
        feature: 'ventilation.bypass.operating.modes.active',
        timestamp: '2022-11-02T13:59:05.607Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        feature: 'ventilation.bypass.configuration.temperature.perceived',
        deviceId: 'ventilation',
        gatewayId: gatewaySerial,
        apiVersion: 1,
        isEnabled: true,
        isReady: true,
        timestamp: '2020-02-02T20:00:00.000Z',
        properties: {
          value: {
            value: 22,
            type: 'number',
            unit: 'celsius',
          },
        },
        commands: {
          setTargetTemperature: {
            name: 'setTargetTemperature',
            isExecutable: true,
            params: {
              temperature: {
                type: 'number',
                constraints: {
                  min: 3,
                  max: 37,
                  stepping: 1,
                },
                required: true,
                description: 'Target temperature',
              },
            },
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.bypass.configuration.temperature.perceived/commands/setTargetTemperature',
          },
        },
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.bypass.configuration.temperature.perceived',
        description:
          'Shows the perceived temperature for bypass mode. Also provides command to set it.',
      },
      {
        feature: 'ventilation.bypass.configuration.temperature.supply',
        deviceId: 'ventilation',
        gatewayId: gatewaySerial,
        apiVersion: 1,
        isEnabled: true,
        isReady: true,
        timestamp: '2020-02-02T20:00:00.000Z',
        properties: {
          value: {
            value: 22,
            type: 'number',
            unit: 'celsius',
          },
        },
        commands: {
          setTargetTemperature: {
            name: 'setTargetTemperature',
            isExecutable: true,
            params: {
              temperature: {
                type: 'number',
                constraints: {
                  min: 3,
                  max: 37,
                  stepping: 1,
                },
                required: true,
                description: 'Target temperature',
              },
            },
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.bypass.configuration.temperature.supply/commands/setTargetTemperature',
          },
        },
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.bypass.configuration.temperature.supply',
        description:
          'Shows the supply temperature for bypass mode. Also provides command to set it.',
      },
      {
        properties: {
          entries: {
            type: 'array',
            value: [],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.status.raw',
        gatewayId: gatewaySerial,
        feature: 'device.messages.status.raw',
        timestamp: '2022-11-02T20:32:31.297Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'notConnected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.airQuality.dust.current',
        gatewayId: gatewaySerial,
        feature: 'ventilation.airQuality.dust.current',
        timestamp: '2022-11-02T20:32:31.220Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'notConnected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.airQuality.fineDust.current',
        gatewayId: gatewaySerial,
        feature: 'ventilation.airQuality.fineDust.current',
        timestamp: '2022-11-02T20:32:31.217Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          operatingHours: {
            type: 'number',
            value: 667,
            unit: 'hours',
          },
          remainingHours: {
            type: 'number',
            value: 8093,
            unit: 'hours',
          },
          overdueHours: {
            type: 'number',
            value: 0,
            unit: 'hours',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.filter.runtime',
        gatewayId: gatewaySerial,
        feature: 'ventilation.filter.runtime',
        timestamp: '2022-11-03T09:32:40.541Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'notConnected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.sensors.humidity.extract',
        gatewayId: gatewaySerial,
        feature: 'ventilation.sensors.humidity.extract',
        timestamp: '2022-11-02T20:32:31.316Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'notConnected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.sensors.humidity.supply',
        gatewayId: gatewaySerial,
        feature: 'ventilation.sensors.humidity.supply',
        timestamp: '2022-11-02T20:32:31.315Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/device.zigbee.active/commands/activate',
            name: 'activate',
            isExecutable: false,
            params: {},
          },
          deactivate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/device.zigbee.active/commands/deactivate',
            name: 'deactivate',
            isExecutable: true,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.zigbee.active',
        gatewayId: gatewaySerial,
        feature: 'device.zigbee.active',
        timestamp: '2022-11-02T13:59:05.607Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'array',
            value: [],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.warnings.raw',
        gatewayId: gatewaySerial,
        feature: 'device.messages.warnings.raw',
        timestamp: '2022-11-02T20:32:31.295Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            value: 'permanent',
            type: 'string',
          },
        },
        commands: {
          setMode: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.operating.modes.active/commands/setMode',
            name: 'setMode',
            isExecutable: true,
            params: {
              mode: {
                type: 'string',
                required: true,
                constraints: {
                  enum: ['permanent', 'ventilation', 'sensorOverride', 'sensorDriven'],
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.operating.modes.active',
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.modes.active',
        timestamp: '2022-11-02T13:59:05.607Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'notConnected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.sensors.temperature.extract',
        gatewayId: gatewaySerial,
        feature: 'ventilation.sensors.temperature.extract',
        timestamp: '2022-11-02T20:32:31.313Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'notConnected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.airQuality.co.current',
        gatewayId: gatewaySerial,
        feature: 'ventilation.airQuality.co.current',
        timestamp: '2022-11-02T20:32:31.262Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          level: {
            type: 'string',
            value: 'levelOne',
          },
          demand: {
            type: 'string',
            value: 'ventilation',
          },
          reason: {
            type: 'string',
            value: 'permanent',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.operating.state',
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.state',
        timestamp: '2022-11-02T20:32:31.291Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          volumeFlow: {
            type: 'number',
            value: 54,
            unit: 'cubicMeter/hour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.levels.levelOne',
        gatewayId: gatewaySerial,
        feature: 'ventilation.levels.levelOne',
        timestamp: '2022-11-02T20:32:31.275Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [],
              current: [
                {
                  priority: 'service',
                  timestamp: '2022-10-06T09:03:18.850Z',
                  accessLevel: 'customer',
                  errorCode: 'P.1',
                  audiences: [
                    'IS-SUPPLIER',
                    'IS-DEVELOPMENT',
                    'IS-MANUFACTURING',
                    'IS-AFTERSALES',
                    'IS-AFTERMARKET',
                    'IS-DEVELOPER-VEG',
                    'IS-BIG-DATA',
                    'IS-MANUFACTURING-VEG',
                  ],
                },
              ],
              gone: [],
            },
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.service.active',
        gatewayId: gatewaySerial,
        feature: 'device.messages.service.active',
        timestamp: '2022-11-01T22:01:13.067Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          input: {
            type: 'number',
            value: 0,
            unit: 'percent',
          },
          output: {
            type: 'number',
            value: 0,
            unit: 'percent',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.air.balance.offset',
        gatewayId: gatewaySerial,
        feature: 'ventilation.air.balance.offset',
        timestamp: '2022-11-02T20:32:31.239Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'notConnected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.sensors.temperature.outside',
        gatewayId: gatewaySerial,
        feature: 'ventilation.sensors.temperature.outside',
        timestamp: '2022-11-02T20:32:31.229Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'notConnected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.sensors.humidity.outdoor',
        gatewayId: gatewaySerial,
        feature: 'ventilation.sensors.humidity.outdoor',
        timestamp: '2022-11-02T20:32:31.312Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [],
              current: [
                {
                  priority: 'criticalError',
                  timestamp: '2022-10-06T11:53:22.964Z',
                  accessLevel: 'customer',
                  errorCode: 'F.520',
                  audiences: [
                    'IS-SUPPLIER',
                    'IS-DEVELOPMENT',
                    'IS-MANUFACTURING',
                    'IS-AFTERSALES',
                    'IS-AFTERMARKET',
                    'IS-DEVELOPER-VEG',
                    'IS-BIG-DATA',
                    'IS-MANUFACTURING-VEG',
                  ],
                },
                {
                  priority: 'criticalError',
                  timestamp: '2022-10-06T11:53:22.964Z',
                  accessLevel: 'customer',
                  errorCode: 'F.520',
                  audiences: [
                    'IS-SUPPLIER',
                    'IS-DEVELOPMENT',
                    'IS-MANUFACTURING',
                    'IS-AFTERSALES',
                    'IS-AFTERMARKET',
                    'IS-DEVELOPER-VEG',
                    'IS-BIG-DATA',
                    'IS-MANUFACTURING-VEG',
                  ],
                },
                {
                  priority: 'criticalError',
                  timestamp: '2022-10-28T12:35:26.582Z',
                  accessLevel: 'customer',
                  errorCode: 'F.898',
                  audiences: [
                    'IS-SUPPLIER',
                    'IS-DEVELOPMENT',
                    'IS-MANUFACTURING',
                    'IS-AFTERSALES',
                    'IS-AFTERMARKET',
                    'IS-DEVELOPER-VEG',
                    'IS-BIG-DATA',
                    'IS-MANUFACTURING-VEG',
                  ],
                },
                {
                  priority: 'criticalError',
                  timestamp: '2022-10-28T12:35:26.582Z',
                  accessLevel: 'customer',
                  errorCode: 'F.900',
                  audiences: [
                    'IS-SUPPLIER',
                    'IS-DEVELOPMENT',
                    'IS-MANUFACTURING',
                    'IS-AFTERSALES',
                    'IS-AFTERMARKET',
                    'IS-DEVELOPER-VEG',
                    'IS-BIG-DATA',
                    'IS-MANUFACTURING-VEG',
                  ],
                },
                {
                  priority: 'criticalError',
                  timestamp: '2022-10-28T12:35:26.582Z',
                  accessLevel: 'customer',
                  errorCode: 'F.904',
                  audiences: [
                    'IS-SUPPLIER',
                    'IS-DEVELOPMENT',
                    'IS-MANUFACTURING',
                    'IS-AFTERSALES',
                    'IS-AFTERMARKET',
                    'IS-DEVELOPER-VEG',
                    'IS-BIG-DATA',
                    'IS-MANUFACTURING-VEG',
                  ],
                },
                {
                  priority: 'criticalError',
                  timestamp: '2022-10-28T12:35:26.582Z',
                  accessLevel: 'customer',
                  errorCode: 'F.902',
                  audiences: [
                    'IS-SUPPLIER',
                    'IS-DEVELOPMENT',
                    'IS-MANUFACTURING',
                    'IS-AFTERSALES',
                    'IS-AFTERMARKET',
                    'IS-DEVELOPER-VEG',
                    'IS-BIG-DATA',
                    'IS-MANUFACTURING-VEG',
                  ],
                },
              ],
              gone: [],
            },
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.errors.active',
        gatewayId: gatewaySerial,
        feature: 'device.errors.active',
        timestamp: '2022-11-01T22:01:13.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
    ];
  }
}
